import classNames from 'classnames'
import { useRouter } from 'next/router'
import FollowBtn from '~/components/business/FollowBtn'
import { MyAvatar } from '~/components/ui/MyAvatar'
import {
  getAiFansCountRank_copyrightStatisticsModule_rankList_edges_node,
  getAiPictureCountRank_copyrightStatisticsModule_rankList_edges_node,
  getAiSameStyleRank_copyrightStatisticsModule_rankList_edges_node,
} from '~/graphqls/types'
import { digitalUnit } from '~/utils'
import { RankChange } from './RankChange'
import { RankNo } from './RankNo'
import { AI_CREATORS_TYPE } from './types'

export const RankList: React.FC<{
  data: (
    | getAiSameStyleRank_copyrightStatisticsModule_rankList_edges_node
    | getAiPictureCountRank_copyrightStatisticsModule_rankList_edges_node
    | getAiFansCountRank_copyrightStatisticsModule_rankList_edges_node
  )[]
  type: AI_CREATORS_TYPE
}> = ({ data, type }) => {
  const router = useRouter()
  return (
    <>
      {data.map((item, index) => (
        <div
          key={item.uid}
          className={classNames('cursor-pointer flex items-center py-8 ', [
            index < data.length - 1 ? ' border-b-[1px] border-neutral-300' : '',
          ])}
          onClick={() => router.push(`/user/${item.uid}`)}
        >
          <div className="flex items-center">
            <RankNo no={index + 1} />
            <div className="w-32 h-32 ml-6 overflow-hidden">
              <MyAvatar
                className="creator-avatar"
                image={item.base?.avatarUrl as string}
                isVip={item.base?.memberDetail?.hold}
                iconClassName="!h-[48px] !w-[48px]"
                size={128}
              />
            </div>
          </div>
          <div className="flex-1 mx-6">
            <div className="font-semibold text-[20px] leading-7 text-neutral-800 line-clamp-1 mb-4">
              {item?.base?.nickname}
            </div>
            <div className="flex items-center text-sm text-neutral-400 mb-4">
              {type === AI_CREATORS_TYPE.SAME_STYlE &&
                !!item?.artworkStatistics?.aiSameStyleCount && (
                  <span>
                    被同款{' '}
                    {digitalUnit(
                      item?.artworkStatistics?.aiSameStyleCount || 0
                    )}{' '}
                    次
                  </span>
                )}
              {type === AI_CREATORS_TYPE.PICTURE_COUNT &&
                !!item?.artworkStatistics?.aiPictureCount && (
                  <span className="ml-4">
                    作画{' '}
                    {digitalUnit(item?.artworkStatistics?.aiPictureCount || 0)}
                    次
                  </span>
                )}
              {!!item?.social?.fansCount && (
                <span className="ml-4">
                  粉丝 {digitalUnit(item?.social?.fansCount || 0)}
                </span>
              )}
              {!!item?.social?.squareCount && (
                <span className="ml-4">
                  发布广场 {digitalUnit(item?.social?.squareCount || 0)}
                </span>
              )}
            </div>
            <div className="flex">
              <RankChange rankChange={item?.artworkStatistics?.rankChange} />
            </div>
          </div>
          <div className="flex" onClick={e => e.stopPropagation()}>
            <FollowBtn
              status={item?.social?.followStatus}
              targetId={item?.base?.uid}
              dark={true}
            />
          </div>
        </div>
      ))}
    </>
  )
}
